import { proStudioUrqlGql as urqlGql } from '@pypestream/api-services';
import { throwErrorWithId } from '@pypestream/utils';
import { pickBy } from 'lodash';

import { checkForErrors } from '../../utils';
import { ProStudioContext, ProStudioEvents } from '../prostudio.xstate.types';
import { SolutionVersion } from '@pypestream/api-services/urql';

const removeEmptyStrings = <T extends Record<string, unknown>>(
  obj: T
): Partial<T> =>
  pickBy(
    obj,
    (value) => value !== '' && value !== null && value !== undefined
  ) as Partial<T>;

export const updateSolution = async (
  ctx: ProStudioContext,
  event: ProStudioEvents
): Promise<{
  draftVersionSolutionData?: SolutionVersion;
  cb?: (
    updatedSolutionData: ProStudioContext['draftVersionSolutionData']
  ) => void;
} | void> => {
  if (event.type !== 'updateSolution') {
    return;
  }

  const { draftVersionSolutionData } = ctx;
  const { version, cb } = event.payload;

  if (!draftVersionSolutionData?.id) {
    throwErrorWithId('Solution version ID is required');
    return;
  }

  const updateSolutionVersionResponse = await urqlGql.updateSolutionVersion({
    version: {
      ...removeEmptyStrings(version),
      id: draftVersionSolutionData.id,
    },
  });

  checkForErrors(updateSolutionVersionResponse);

  const updatedSolutionData = updateSolutionVersionResponse.data?.admin_
    ?.updateSolutionVersion as SolutionVersion | undefined;

  return {
    draftVersionSolutionData: updatedSolutionData,
    cb: cb ? () => cb(updatedSolutionData as SolutionVersion) : undefined,
  };
};
